export const ensureAbsoluteUrl = (url, baseUrl) => {
	if (!url || !baseUrl) return url;

	try {
		const parsedUrl = new URL(url);
		return `${baseUrl}${parsedUrl.pathname}${parsedUrl.search}${parsedUrl.hash}`;
	} catch (error) {
		return url;
	}
};
